/*!
                         _____                                                   
  /  _  \   ____   ____   ____ _____    ____               
 /  /_\  \_/ __ \ / ___\_/ __ \\__  \  /    \              
/    |    \  ___// /_/  >  ___/ / __ \|   |  \             
\____|__  /\___  >___  / \___  >____  /___|  /             
        \/     \/_____/      \/     \/     \/              
  _________      .__          __  .__                      
 /   _____/ ____ |  |  __ ___/  |_|__| ____   ____   ______
 \_____  \ /  _ \|  | |  |  \   __\  |/  _ \ /    \ /  ___/
 /        (  <_> )  |_|  |  /|  | |  (  <_> )   |  \\___ \ 
/_______  /\____/|____/____/ |__| |__|\____/|___|  /____  >                                                                                                                                                                                                                                                                                                                 
=========================================================
* Aegean Solutions - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Marios Kaldellis

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import Sizedbox from 'components/Sizedbox';
import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Icon,
  Select,
  SimpleGrid,
  useColorModeValue,
  Progress,
  Button
} from "@chakra-ui/react";
// Assets
import Usa from "assets/img/dashboards/usa.png";
// Custom components
import MiniCalendar from "components/calendar/MiniCalendar";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React from "react";
import {
  MdAddTask,
  MdAttachMoney,
  MdBarChart,
  MdFileCopy,
  MdOutlinePerson4,
  MdAdd
} from "react-icons/md";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import PieCard from "views/admin/default/components/PieCard";
import Tasks from "views/admin/default/components/Tasks";
import TotalSpent from "views/admin/default/components/TotalSpent";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import { Images } from '../../../components/configs';
import {
  columnsDataCheck,
  columnsDataComplex,
} from "views/admin/default/variables/columnsData";
import tableDataCheck from "views/admin/default/variables/tableDataCheck.json";
import tableDataComplex from "views/admin/default/variables/tableDataComplex.json";

export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 6 }}
        gap='20px'
        mb='20px'>
        {/* <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdBarChart} color={brandColor} />
              }
            />
          }
          name='Earnings'
          value='$350.4'
        /> */}
        {/* <Progress
          variant='table'
          colorScheme='brandScheme'
          h='8px'
          w='108px'
          value={30}
        /> */}
        {/* <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='50px' h='50px' as={MdOutlinePerson4} color={brandColor} />
              }
            />
          }
          name='Spend this month'
          value='$642.39'
        /> */}
        {/* Panw panw */}
        <MiniStatistics growth='+23%' image={Images.ArtefactBot} name='Artefact Bot' value='30.4' link='https://memobot.eu/' />
        <Sizedbox width={1}/>
        <MiniStatistics growth='+23%' image={Images.KazantzakisBot} name='Kazantzakis Bot' value='60.8'  link='https://memobot.eu/' />
        <Sizedbox width={1}/>
        <MiniStatistics growth='+23%' image={Images.MuseumBot} name='Museum Bot' value='90'  link='https://www.museumbot.eu/'/>
         {/* <Sizedbox width={0.2}/> 
        <MiniStatistics growth='+23%' image={MdOutlinePerson4} name='Total Chatbots' value='3' /> */}

        {/* <MiniStatistics
          endContent={
            <Flex me='-16px' mt='10px'>
              <FormLabel htmlFor='balance'>
                <Avatar src={Usa} />
              </FormLabel>
              <Select
                id='balance'
                variant='mini'
                mt='5px'
                me='0px'
                defaultValue='usd'>
                <option value='usd'>USD</option>
                <option value='eur'>EUR</option>
                <option value='gba'>GBA</option>
              </Select>
            </Flex>
          }
          name='Your balance'
          value='$1,000'
        /> */}
        {/* <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg='linear-gradient(90deg, #4481EB 0%, #04BEFE 100%)'
              icon={<Icon w='28px' h='28px' as={MdAddTask} color='white' />}
            />
          }
          name='New Tasks'
          value='154'
        /> */}
        {/* <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdOutlinePerson4} color={brandColor} />
              }
            />
          }
          name='Total Chatbots'
          value='3'
          growth='s'
        /> */}
      </SimpleGrid>


      {/* <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px' mb='20px'>
        <TotalSpent />
        <WeeklyRevenue />
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap='20px' mb='20px'>
         <CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} /> 
        <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px'>
          <DailyTraffic />
          <PieCard />
        </SimpleGrid>
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap='20px' mb='20px'>
        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
         <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px'>
          <Tasks />
          <MiniCalendar h='100%' minW='100%' selectRange={false} />
        </SimpleGrid>
      </SimpleGrid> */}
      <Flex justifyContent="center" alignItems="center" h="100%">
        <Button
          style={{
            padding: '15px',
            backgroundColor: '#20639b',
            color: 'white',
          }}
        >
          <Icon w='32px' h='32px' as={MdAdd} color={"white"} />Create a Chatbot
        </Button>
      </Flex>
      
      <SimpleGrid padding={5} columns={{ base: 1, md: 2, xl: 2 }} gap='20px' mb='20px'>
      <MiniStatistics growth='+23%' image={Images.ServiceBot} name='Service Bot' value='90'  link='https://www.museumbot.eu/'/>
        <TotalSpent />
        {/* <WeeklyRevenue /> */}
      </SimpleGrid>
      {/* <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap='20px' mb='20px'>
        <CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} />
        <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px'>
          <DailyTraffic />
          <PieCard />
        </SimpleGrid>
      </SimpleGrid> */}
      {/* <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap='20px' mb='20px'>
        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
        <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px'>
          <Tasks />
          <MiniCalendar h='100%' minW='100%' selectRange={false} />
        </SimpleGrid>
      </SimpleGrid> */}
    </Box>
  );
}
